import React, { useEffect } from 'react';
import {
  UserInfoContainer,
  UserPageContent,
  UserPageContentWrap,
  UserPageTable,
  UserPageTableRow,
  UserPageWrap,
} from './style';
import { useDispatch, useSelector } from 'react-redux';
import { getSingleUser } from 'redux/slices/userSlice';
import { setDomainId, setDomainName } from 'redux/slices/selectedNodeSlice';

function UserPage() {
  const dispatch = useDispatch();
  const { singleUserData, singleUserLoading } = useSelector((state) => state.getUsers);

  useEffect(() => {
    const dn = localStorage.getItem('dn');
    const fqdn = localStorage.getItem('domain');
    const domainId = Number(localStorage.getItem('domainId'));
    dispatch(getSingleUser({ userName: dn, fqdn: fqdn, domainId: domainId }));
    dispatch(setDomainName(fqdn));
    dispatch(setDomainId(domainId));
  }, [dispatch]);

  return (
    <UserPageWrap className='af-userpage-body-wrap'>
      {!singleUserLoading && singleUserData && (
        <>
          <UserPageContent className='af-userpage-content-wrap'>
            <UserPageContentWrap className='af-userpage-content'>
              <UserInfoContainer className='af-userpage-info-container'>
                <UserPageTable className='af-userpage-table-wrap'>
                  <tbody className='af-userpage-table-body'>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Name:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.displayName}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Given Name:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.givenName}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Initials:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.initials}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Surname:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.surname}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>UPN:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.userPrincipalName}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Email:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.email}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Lock Status:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.isLock ? 'Locked' : 'Unlocked'}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Account Status:</th>
                      <td className='af-userpage-table-row-data'>
                        {singleUserData.isEnabled ? 'Enabled' : 'Disabled'}
                      </td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Street:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.street}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Country/Region:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.country}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>State/Province:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.state}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>City:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.city}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>P.O.Box:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.poBox}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-table-row-wrap'>
                      <th className='af-userpage-table-row-head'>Zip/Postal Code:</th>
                      <td className='af-userpage-table-row-data'>{singleUserData.zip}</td>
                    </UserPageTableRow>
                  </tbody>
                </UserPageTable>
              </UserInfoContainer>
            </UserPageContentWrap>
          </UserPageContent>
          <UserPageContent className='af-userpage-content-second-wrap'>
            <UserPageContentWrap className='af-userpage-content-second'>
              <UserInfoContainer className='af-userpage-second-info-container'>
                <UserPageTable className='af-userpage-second-table-wrap'>
                  <tbody className='af-userpage-second-table-body'>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Job Title:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.jobTitle}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Department:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.department}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Company:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.company}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Description:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.description}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Office:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.office}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Telephone Number:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.telephoneNumber}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Web Page:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.webPage}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Created:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.createdAt}</td>
                    </UserPageTableRow>
                    <UserPageTableRow className='af-userpage-second-table-row-wrap'>
                      <th className='af-userpage-second-table-row-head'>Last Changed:</th>
                      <td className='af-userpage-second-table-row-data'>{singleUserData.lastChanges}</td>
                    </UserPageTableRow>
                  </tbody>
                </UserPageTable>
              </UserInfoContainer>
            </UserPageContentWrap>
          </UserPageContent>
        </>
      )}
    </UserPageWrap>
  );
}

export default UserPage;
